// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lh-bE","colBig":"styles_colBig__3U4SI","colSmall":"styles_colSmall__1UmT9"};